import React from 'react';

import { Nullable } from '@clearverify/types';

import { useCognito } from '../app';

export const useUserMfaTotpUriKey = (email: Nullable<string>, accessToken: Nullable<string>) => {
  const { mfaGenerateTotpUriKey: generate } = useCognito();

  const [isGenerating, setIsGenerating] = React.useState(false);
  const [uriKey, setUriKey] = React.useState<string>();

  // for useEffect in dev mode
  const generatingInProgress = React.useRef(false);

  const mfaGenerateTotpUriKey = React.useCallback(
    async (email: string, accessToken: string): Promise<ReturnType<typeof generate> | null> => {
      try {
        setIsGenerating(true);
        generatingInProgress.current = true;
        return await generate({ email, accessToken });
      } catch (error) {
        console.error(error);
      } finally {
        setIsGenerating(false);
        generatingInProgress.current = false;
      }
      return null;
    },
    [generate],
  );

  React.useEffect(() => {
    if (!email || !accessToken) return;

    const getData = async () => {
      const data = await mfaGenerateTotpUriKey(email, accessToken);
      setUriKey(data?.uriKey);
    };

    if (!uriKey && !generatingInProgress.current) {
      getData();
    }
  }, [accessToken, email, mfaGenerateTotpUriKey, uriKey]);

  return {
    uriKey,
    generating: isGenerating,
  };
};
